import * as React from 'react';
import styled, {css} from 'styled-components'
import {ConstBorderRound, ConstColor, ConstFontStyle, ConstPadding} from "../../../../config/styles_const/styles_const";
import TextareaAutosize from 'react-autosize-textarea';
import {RefObject} from "react";

interface IProps
    extends TextareaAutosize.RequiredProps {
    hasError?: boolean;
    textareaRef?: RefObject<HTMLTextAreaElement>;
}

const FormTextareaDefault: React.FC<IProps> = (props) => {

    const { hasError, textareaRef, ...TextareaProps } = props;

    return (<TextareaAutosize　style={{ resize: "none" }} ref={textareaRef} {...TextareaProps}/>)

};

const FormTextarea = styled(FormTextareaDefault)`
    width: 100%;
    padding: ${ConstPadding.FormDefaultPadding};
    color: ${ConstColor.Base};
    // border
    border: 1px solid ${ConstColor.Gray};
    border-radius: ${ConstBorderRound.CornerRoundAll};
    // font
    font-style: normal;
    font-weight: ${ConstFontStyle.FormDefault.fontWeight};
    font-size: ${ConstFontStyle.FormDefault.fontSize};
    line-height: ${ConstFontStyle.FormDefault.lineHeight};
    &::placeholder {
      color: ${ConstColor.PlaceholderAndBorder};
    }
    &:read-only {
        background: ${ConstColor.Readonly};
        border: 1px solid ${ConstColor.Readonly};
    }
    &:disabled {
        background: ${ConstColor.Readonly};
        border: 1px solid ${ConstColor.Readonly};
    }
    &:focus {
      outline: 0;
      border: 1px solid ${ConstColor.Focus};
    }
    ${props => props.hasError && css`
      && {
          border: 1px solid ${ConstColor.Error};
          color: ${ConstColor.Error}
      }
    `}
`;

export default FormTextarea


// WEBPACK FOOTER //
// ./src/presentation/common/atom/form/form_textarea.tsx